/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

// MAIN
import linesStateReducerParts from './main/reducerParts';
import { initialState as linesStateInitialState } from './main/initialState';

// FILTERS
import filtersRecuerParts from './filters/reducerParts';
import { initialState as filtersInitialState } from './filters/initialState';

const initialState = {
	...linesStateInitialState,
	...filtersInitialState,
};

const reducerParts = {
	...linesStateReducerParts,
	...filtersRecuerParts,
};

export default handleActions(reducerParts, initialState);
